const Footer = () => {
  return (
    <footer className="footer">
      <p>© 2026 Online ස්කෝලේ</p>
    </footer>
  );
};

export default Footer;

